import axios from "axios";
import store from "@/store/vuex";

const server_uri = process.env.VUE_APP_SERVER_URI;


export function default_post(body, path) {
  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        Authorization: `Bearer ${store.getters.getSACIToken}`
      } // Obtem access_token
    };

    axios
      .post(`${server_uri}${path}`, body, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        reject([]);
      });
  });
}

export function default_get(path) {
  return new Promise((resolve, reject) => {
    
    const config = {
      headers: {
        Authorization: `Bearer ${store.getters.getSACIToken}`
      } // Obtem access_token
    };

    axios
      .get(`${server_uri}${path}`, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        reject([]);
      });
  });
}

export function default_func(body, path) {
  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        Authorization: `Bearer ${store.getters.getSACIToken}`
      } // Obtem access_token
    };

    axios
      .post(`${server_uri}${path}`, body, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        reject([]);
      });
  });
}

export function reopenRequest(hash) {
  return new Promise((resolve, reject) => {
    const idVinculo = store.getters.getIdVinculo;
    console.log("open", hash);

    const body = {
      hash,
      idVinculo: idVinculo
    };

    axios
      .post(`${server_uri}/db/paas/request/reopen`, body)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        reject([]);
      });
  });
}

//Get report from backend
export const toggleDefaultPreference = () => {
  return default_func(
    {},
    "/paas/classesRequest/toggleDefaultPreference"
  );
};

export const duplicateRequest = request => {
  return default_func(
    { ...request },
    "/paas/classesRequest/duplicate"
  );
};

export const duplicateRequestAndUpdate = request => {
  return default_func(
    { ...request },
    "/paas/classesRequest/duplicateAndUpdate"
  );
};

export const sendPaasClassesRequest = async (_classes, hash, admin = false) => {

    const author = store.getters.getUserName;


    let classes = _classes.map(e => {
      return {
        ...e,
        id: isNaN(Number(e.id)) ? undefined : e.id,
        author: admin ? e.author ?? author : author,
        hash: hash,
      };
    });

    if(admin) {
      return default_func({ classes }, "/paas/classesRequest/addClasses/admin")
    }else {
      return default_func({ classes }, "/paas/classesRequest/addClasses")
    }
  
}


